const HUMAN_INPUT_EVENTS = ['keydown', 'pointerdown', 'pointermove', 'touchstart', 'wheel'];
const VISIBLE_DWELL_MS = 5_000;

let human = false;
let pending: (() => void)[] = [];
let dwellTimeout: ReturnType<typeof setTimeout> | undefined;

// Headless browsers posing as visitors load a page and leave within seconds without any input, so a guest's
// analytics wait for input or five seconds in view. What was held is dropped with the page if neither comes.
export function whenHuman(send: () => void): void {
  if (human) send();
  else pending.push(send);
}

export function isHuman(): boolean {
  return human;
}

export function markHuman(): void {
  if (human) return;
  human = true;
  HUMAN_INPUT_EVENTS.forEach(type => window.removeEventListener(type, handleInput, true));
  document.removeEventListener('visibilitychange', handleVisibilityChange);
  clearTimeout(dwellTimeout);
  const held = pending;
  pending = [];
  held.forEach(send => send());
}

// `isTrusted` is false for input a script dispatches.
function handleInput(event: Event) {
  if (event.isTrusted) markHuman();
}

function handleVisibilityChange() {
  clearTimeout(dwellTimeout);
  if (document.visibilityState === 'visible') dwellTimeout = setTimeout(markHuman, VISIBLE_DWELL_MS);
}

HUMAN_INPUT_EVENTS.forEach(type => window.addEventListener(type, handleInput, { capture: true, passive: true }));
document.addEventListener('visibilitychange', handleVisibilityChange);
handleVisibilityChange();
